"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalStorage = void 0;
var react_1 = __importDefault(require("react"));
// NOTE: useStateっぽく使いたい為のWrapperですが、localStorage自体はどこからでも触れるため、値が同期されていることが必ずしも保証されていません。
var useLocalStorage = function (key) {
    var _a = react_1.default.useState(localStorage.getItem(key)), value = _a[0], setValue = _a[1];
    var setter = react_1.default.useCallback(function (value) {
        if (value) {
            localStorage.setItem(key, value);
            setValue(value);
        }
        else {
            localStorage.removeItem(key);
            setValue(null);
        }
    }, []);
    return [value, setter];
};
exports.useLocalStorage = useLocalStorage;
